@use '@fpsm/cxy-scss' as cxy;

body:has(dialog[open]) {
  overflow: hidden;
}

.bettingInsightsSection {
  grid-area: section;
  color: var(--cxy-color-content-default);
  padding-inline: var(--cxy-spacing-4);
}
@media (min-width: 801px) {
  .bettingInsightsSection {
    padding-inline-start: 0;
  }
}

.bettingInsightsResults {
  @include cxy.stack(var(--cxy-spacing-4));
  padding-bottom: var(--cxy-spacing-1);
}

.bettingInsightsPagination {
  grid-area: pagination;
  padding: var(--cxy-spacing-8) 0;
  display: flex;
  justify-content: center;
}

.isVisiblyHidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.loadingState {
  @include cxy.stack(var(--cxy-spacing-8));
}

.loadMore > div {
  --base-size: 1px;
  margin-inline-start: var(--cxy-spacing-2);
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .loadMore {
    background-color: var(--cxy-color-black);
    color: var(--cxy-color-white);
    font-weight: var(--cxy-fontWeight-normal);
  }

  .lastPage {
    margin-bottom: 60px;
  }
}

.disclaimer {
  font-size: var(--cxy-fontSize-s);
  margin: var(--cxy-spacing-4) 0;
}
